module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 White.0ee3f501.png";